// extracted by mini-css-extract-plugin
export default {"ace-c-invoice-document-form__file-name":"invoice-document-form__file-name---4bc81ef4"};